import type { Permission } from '@crm/contracts';
import { Link, Outlet } from 'react-router';

import { useOrganizationAccess } from '@/entities/session';
import { paths } from '@/shared/config';
import { useOrganizationId } from '@/shared/lib';
import { EmptyState } from '@/shared/ui/state';

/** Hides pages the user cannot use; the BFF and the gateway enforce the same rule. */
interface OrganizationGuardProps {
  admin?: boolean;
  /** A section's view permission. */
  permission?: Permission;
}

export function OrganizationGuard({ admin = false, permission }: OrganizationGuardProps) {
  const { isMember, canManage, can } = useOrganizationAccess(useOrganizationId());
  if (!isMember || (admin && !canManage) || (permission && !can(permission))) {
    return (
      <EmptyState title="Нет доступа к этому разделу">
        <Link to={paths.organizations}>К списку организаций</Link>
      </EmptyState>
    );
  }
  return <Outlet />;
}
